import { render, staticRenderFns } from "./docPDN_PDL.vue?vue&type=template&id=14974227&scoped=true"
import script from "./docPDN_PDL.vue?vue&type=script&lang=js"
export * from "./docPDN_PDL.vue?vue&type=script&lang=js"
import style0 from "./docPDN_PDL.vue?vue&type=style&index=0&id=14974227&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14974227",
  null
  
)

export default component.exports